import * as React from "react";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

interface AppsProps {
  applications: {
    id: number;
    name: string;
    url: string;
    sequence: number;
  }[];
  btnsDisabled: boolean;
  hostname: string;
}

const AppDiv = styled("div")(() => ({
  height: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const Apps: React.FC<AppsProps> = ({ applications, btnsDisabled, hostname }) => {
  if (!applications) {
    // We are getting list of applications client-side, return nothing until applications
    // API call has completed and has some value. This could be replaced with a loader, but the
    // call is quick enough thats it's fine not display anything.
    return null;
  }

  if (applications?.length == 0) {
    return <AppDiv>No applications configured for workflow type</AppDiv>;
  }

  applications?.sort((a, b) => a?.sequence - b?.sequence);

  return (
    <AppDiv>
      {applications?.map((app) => {
        return (
          <Button
            variant="contained"
            key={app?.id} // Id is guaranteed to be unique
            disabled={!hostname || btnsDisabled}
            href={"https://" + hostname + "/" + app?.url}
            target="_blank"
          >
            {app.name}
          </Button>
        );
      })}
    </AppDiv>
  );
};
